import {NG_EVENT_PLUGINS} from "@taiga-ui/event-plugins";
import {APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, Router, withComponentInputBinding} from '@angular/router';

import {routes} from './app.routes';
import {provideKeycloakAngular} from './keycloak.provider';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {includeBearerTokenInterceptor} from 'keycloak-angular';
import {withNgxsReduxDevtoolsPlugin} from '@ngxs/devtools-plugin';
import {withNgxsFormPlugin} from '@ngxs/form-plugin';
import {withNgxsLoggerPlugin} from '@ngxs/logger-plugin';
import {withNgxsRouterPlugin} from '@ngxs/router-plugin';
import {withNgxsStoragePlugin} from '@ngxs/storage-plugin';
import {withNgxsWebSocketPlugin} from '@ngxs/websocket-plugin';
import {provideStore} from '@ngxs/store';
import {DashboardState} from '../dashboard/+state/dashboard.state';
import {provideLayoutStateListener} from '../core/initializers/layout.init';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideEnv} from './env.provider';
import {OrgOnboardingState} from '../org/onboarding/+state/state';
import {provideCreateOrgInit} from '../core/initializers/create-org.init';
import {OrgsState} from '../core/+state/orgs/state';
import {provideGetOrgsInit, provideSetActiveOrgInit, provideSetOrgInit} from '../core/initializers/get-org.init';
import {orgInterceptor} from '../core/interceptors/org.interceptor';
import {provideCreateAssetInit} from '../core/initializers/create-asset.init';
import {OverviewState} from "../overview/+state/state";
import {AssetDetailsMapState} from '../assets/asset/+state/state';
import {TeamMembersState} from '../org/team-members/+state/state';
import {provideWsConnector} from '../core/initializers/ws-connector.init';
import * as Sentry from "@sentry/angular";
import {searchQueryActionListener} from '../core/+state/search/action-listener';
import {SearchState} from '../core/+state/search/state';
import {readNotificationInit} from '../core/initializers/read-notification.init';
import { provideNotificationClickHandler } from "../notifications/components/notification-click.handler";
import { provideMarkdown } from "ngx-markdown";

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideAnimationsAsync(),
    provideKeycloakAngular(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withComponentInputBinding()),
    NG_EVENT_PLUGINS,
    provideHttpClient(withInterceptors([
      includeBearerTokenInterceptor,
      orgInterceptor
    ])),
    provideStore(
      [
        AssetDetailsMapState,
        DashboardState,
        OrgOnboardingState,
        OrgsState,
        OverviewState,
        SearchState,
        TeamMembersState,
      ],
      withNgxsReduxDevtoolsPlugin({
        name: 'Track Stream',
      }),
      withNgxsFormPlugin(),
      withNgxsLoggerPlugin({
        disabled: import.meta?.env?.NG_APP_DISABLE_STATE_LOGGER,
      }),
      withNgxsRouterPlugin(),
      withNgxsStoragePlugin({
        keys: [DashboardState, OrgOnboardingState, OrgsState, SearchState]
      }),
      withNgxsWebSocketPlugin()
    ),
    provideLayoutStateListener,
    provideEnv,
    provideCreateOrgInit,
    provideGetOrgsInit,
    provideSetOrgInit,
    provideSetActiveOrgInit,
    provideCreateAssetInit,
    provideWsConnector,
    searchQueryActionListener,
    readNotificationInit,
    provideNotificationClickHandler,
    provideMarkdown(),
  ]
};
